import apiService from '@/api/apiService';

// 管理員修改自己的密碼
export const changeManagerPassword = async (currentPassword, newPassword) => {
    const url = '/api/admin/manager/password';

    return apiService.PUT(url, {
        current_password: currentPassword,
        password: newPassword
    });
};

